<template>
  <validation-observer
    ref="cancelElectronicSignatureForm"
    v-slot="{}"
    tag="form"
  >
    <div class="bg-secondary-9 rounded-lg container-border p-4 mb-3">
      <div class="row">
        <div class="col-12 mb-1">
          <label class="color-gray-7 font-16 font-weight-bold">
            <i class="fas mr-1 fa-times-circle p-1 color-orange font-18" />
            Cancelación de Firma
          </label>
        </div>
        <div class="col-12 mt-3">
          <label class="data-title mb-0">Razón de Cancelación:</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="reason"
              :count-classes="['float-right']"
              custom-error-msg="La razón es requerida."
              :error="errors[0]"
              :maxlength="3000"
              placeholder="Ingresa la razón"
              show-char-count
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="onSaveHandler"
              />
            </div>
            <div class="mx-0">
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="onCancelHandler"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
//components
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

//services
import { cancelSignature as _cancelSignature } from '@/services/uspqrp/signatures-contractor.api';
import { changeElectronicDocumentStatus as _changeElectronicDocumentStatus } from '@/services/uspqrp/intervention-plan.api.js';

//utils
import SignatureDocumentStatus from '@/utils/constants/signatureDocumentStatus.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'SignatureElectronicCancel',
  components: {
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    planId: {
      type: Number,
      default: null,
      required: false,
    },
    documentTypeId: {
      type: Number,
      default: null,
      required: false,
    },
    digitalSignatureDocumentId: {
      type: String,
      default: null,
      required: false,
    },
    digitalSignatureDocumentStatusId: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      reason: null,
    };
  },
  methods: {
    async onSaveHandler() {
      const isFormValid = await this.$refs.cancelElectronicSignatureForm.validate();
      if (!isFormValid) return;
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea <b class="text-capitalize">cancelar</b> firma electrónica del Plan de Intervención?`,
        'Sí',
        'No'
      );
      if (!answer) return;
      const isForRenderedIneffective =
        this.digitalSignatureDocumentStatusId ===
        SignatureDocumentStatus.Signed;
      const { data: dataCancel } = await _cancelSignature(
        this.digitalSignatureDocumentId,
        this.reason,
        isForRenderedIneffective
      );
      if (dataCancel.isSuccess) {
        const params = {
          planId: this.planId,
          documentTypeId: this.documentTypeId,
          newDocumentStatusId: SignatureDocumentStatus.DocNotGenerated,
        };
        const { data } = await _changeElectronicDocumentStatus(params);
        if (data) {
          this.ShowToast(
            'Confirmación',
            `Documento para Firma Electrónica cancelado exitosamente.`,
            'success'
          );
          this.reason = null;
          this.$emit('hide', true);
        }
      } else {
        this.ShowToast('Alerta', dataCancel.errorMessage || 'error', 'error');
        return;
      }
    },
    onCancelHandler() {
      this.reason = null;
      this.$emit('hide');
    },
  },
};
</script>

<style></style>
